import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const CalendarClockSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default CalendarClockSVG;
